import { useNavigate } from 'react-router-dom';

import { routes } from 'core/routing';
import { useHasAccess } from 'core/user/role';
import { useUser } from 'core/user/user';
import RecentProjects from 'features/landing/RecentProjects';
import RecentSites from 'features/landing/RecentSites';
import useRecentProjectsQuery from 'shared/api/projects/useRecentProjectsQuery';
import useRecentSitesQuery from 'shared/api/projects/useRecentSitesQuery';
import ActionButton from 'shared/components/ActionButton';
import SpacingLayout from 'shared/components/SpacingLayout';
import styles from 'theme/features/landing/landing.module.scss';

const Landing = () => {
  const navigate = useNavigate();

  const { data: recentProjects } = useRecentProjectsQuery();
  const { data: recentSites } = useRecentSitesQuery();

  const { user } = useUser();
  const { hasEditAccess } = useHasAccess();

  return (
    <SpacingLayout className={styles.wrapper}>
      <div className={styles.heading}>
        <h1>
          Hi {user.firstName}, <br /> <strong>Welcome back!</strong>
        </h1>
        {hasEditAccess() && (
          <ActionButton size="sm" onClick={() => navigate(routes.createProject())}>
            Create Project
          </ActionButton>
        )}
      </div>
      <RecentProjects projects={recentProjects} />
      <RecentSites sites={recentSites} />
    </SpacingLayout>
  );
};

export default Landing;
